<app-side-menu class="container">
    <div content id="main-content" style="height: 100%">
        <router-outlet></router-outlet>
    </div>
</app-side-menu>
